const FORMS = {
    DADOS_CLIENTE: 'formDadosCliente',
    TIPO_SIMULACAO_MODAL: 'formModalTipoSimulacao',
    FORMA_PAGAMENTO: 'formFormaDePagamento',
    ENDERECO: 'formModalCadastroEndereco',
    VIGENCIA: 'formVigencia',
    NOVO_BEM: 'formNovoBem',
    GEOLOCALIZACAO: 'formCadastroGeolocalizacao',
    DADOS_CONTATO: 'formDadosContato',
    COCORRETAGEM: 'formCoCorretagem',
    DETALHES_EQUIPAMENTOS: 'formDetalhesEquipamento',
    MODAL_CONTEUDO: 'formModalConteudo'
};

export default FORMS;
